import './solenne/style';
import FormStructure from './solenne/form_structure';

export default FormStructure;